import SparkMD5 from 'spark-md5';

// チャンクサイズ（2MB）
const CHUNK_SIZE = 1024 * 1024;

export const calculateFileMD5 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();
    let currentChunk = 0;
    const chunks = Math.ceil(file.size / CHUNK_SIZE);

    const loadNext = () => {
      const start = currentChunk * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      
      fileReader.readAsArrayBuffer(chunk);
    };

    fileReader.onload = (e) => {
      if (e.target?.result) {
        spark.append(e.target.result as ArrayBuffer);
        currentChunk++;

        if (currentChunk < chunks) {
          // 次のチャンクを処理（非同期で実行してUIをブロックしない）
          setTimeout(loadNext, 0);
        } else {
          // 全チャンク処理完了
          const hashHex = spark.end();
          const hashBase64 = btoa(
            hashHex.match(/\w{2}/g)!
              .map(a => String.fromCharCode(parseInt(a, 16)))
              .join('')
          );
          resolve(hashBase64);
        }
      }
    };

    fileReader.onerror = () => {
      reject(new Error('ファイルの読み込みに失敗しました'));
    };

    // 最初のチャンクを開始
    loadNext();
  });
};
